module.exports = __webpack_public_path__ + "img/redvertical.4e23b22b.png";